import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { TranslateModule } from '@ngx-translate/core';

import { GiftTicketDownloadService } from '../services/gift-ticket-download.service';
import { GiftTicketDownloadEffects } from '../store/gift-ticket-download.effects';

import { GiftTicketDownloadComponent } from './gift-ticket-download.component';

import { OrderService } from '@api/order/order.service';
import { ProductCommonModule } from '@shared/product/product-common.module';
import { ShopcartModule } from '@shared/shopcart/shopcart.module';
import { DialogModule } from '@ui/dialog/dialog.module';
import { SvgIcon2Component } from '@ui/svg-icon/svg-icon.component';

@NgModule({
    declarations: [GiftTicketDownloadComponent],
    providers: [GiftTicketDownloadService, OrderService],
    imports: [
        CommonModule,
        TranslateModule.forChild(),
        EffectsModule.forFeature([GiftTicketDownloadEffects]),
        DialogModule,
        ProductCommonModule, // NOTE: Módulo potencialmente no necesario después de añadir ProductCommonModule
        ShopcartModule,
        SvgIcon2Component,
    ],
})

export class GiftTicketDownloadModule {}
